import { useParams } from 'react-router';
import { DEFAULT_LOCALE, isLocale, type Locale } from './locales';

/** Current UI language = the /:lang URL segment (validated by LocaleGate). */
export function useLocale(): Locale {
  const { lang } = useParams();
  return isLocale(lang) ? lang : DEFAULT_LOCALE;
}
